<template>
  <b-sidebar no-header v-model="show" backdrop shadow right class="sidebar-edit-proposal" @change="hasClosedSidebar" ref="sidebar_edit_proposal">
    <div class="p-1">
      <div class="d-flex justify-content-end">
        <feather-icon 
          icon="XIcon" 
          size="20" 
          class="close-sidebar-icon"
          @click="show = false"
        />
      </div>
    </div>

    <samples :samples="get_samples" :proposal_uuid="details.details_proposal_uuid" v-if="section === 'samples'" :is_editing="true" :hide_sidebar="hide_sidebar" @update_details="updateProposal"/>
    
    <title-description 
      v-else-if="section === 'title_description'" 
      :proposal_uuid="details.details_proposal_uuid ? details.details_proposal_uuid : ''" 
      :proposal="getOnlySomeDataFromDetails(details, ['title', 'description'])"
      :edit_by_agency="edit_by_agency"
      @update_proposal="updateProposal"   
    />
    <talent-details
      v-else-if="section === 'talent_details'"
      :details="details"
      @update_proposal="updateProposal"
    />
    <deals-component 
      v-if="section === 'deals'" 
      :is_editing="Object.keys(data_for_sidebar).length > 0" 
      :deal_selected="data_for_sidebar" 
      :chat_uuid="chat_uuid"
      :edit_by_agency="edit_by_agency"
      :owner_is_brandme_talent="owner_is_brandme_talent"
      @update_proposal="updateDeals"
      @update_private_deal="updatePrivateDeals"
    />
  </b-sidebar>
</template>

<script>
import { 
  BSidebar,
} from 'bootstrap-vue';
import { getOnlySomeDataFromDetails } from '@/domain/proposal/mapper/proposal-mapper';
import { showToast } from '@/libs/utils/others';

export default {
  name: 'sidebarEditProposal',
  components: {
    BSidebar,
    samples: () => import('./samples.vue'),
    titleDescription: () => import('./titleDescription.vue'),
    dealsComponent: () => import('./dealsComponent.vue'),
    talentDetails: () => import('./talentDetails.vue'),
  },
  data() {
    return {
      show: this.open_sidebar_edit,
      section: this.section_dad
    }
  },
  props: {
    open_sidebar_edit: {
      type: Boolean,
      default: false,
    },
    details: {
      type: Object,
      default: () => {
        return {}
      }
    },
    section_dad: {
      type: String,
    },
    data_for_sidebar: {
      type: Object,
      default: () => {
        return {}
      }
    },
    chat_uuid: {
      type: String,
      default: null,
    },
    edit_by_agency: {
      type: Boolean,
      default: false,
    },
    hide_sidebar: {
      type: Boolean,
      default: true,
    },
    owner_is_brandme_talent: {
      type: Boolean,
      default: null,
    }
  },
  computed: {
    get_samples() {
      return this.details.images ?? []
    }
  },
  methods: {
    getOnlySomeDataFromDetails,
    updatePrivateDeals(private_deal) {
      this.$emit('update_private_deal', private_deal, 'create');
      this.show = false;
    },
    hasClosedSidebar() {
      this.$refs.sidebar_edit_proposal.$el.classList.remove('open-sidebar-edit-proposal')
      if (localStorage.getItem('steps')) localStorage.removeItem('steps');
      this.$emit("close_siderbar");
      this.show = false;
    },
    updateProposal(response, key, hide_sidebar = true) {
      if (hide_sidebar) this.show = false;
      showToast(this, 'success', 'CheckCircleIcon', this.$t('creator.proposalUpdated'), this.$t('creator.proposalUpdatedText'))

      if (!key) {
        this.$emit('update_proposal', response);
        return;
      }

      this.$emit('update_proposal', response, key);
    },
    updateDeals(response, action) { 
      this.$emit('update_deals', response, action);
      this.show = false;
      showToast(this, 'success', 'CheckCircleIcon', this.$t('creator.proposalUpdated'), this.$t('creator.proposalUpdatedText'))
    },
    changeViewConnection() {
      this.section = 'connection';
    },
    resetProposal(proposal) {
      this.$emit('reset_proposal', proposal)
      this.show = false;
    },
  },
}

</script>

<style scoped>
.close-sidebar-icon:hover {
  background-color: rgba(219, 219, 219, 0.5);
  border-radius: 50%;
  cursor: pointer;
}
</style>
<style>
.sidebar-edit-proposal > .b-sidebar {
  width: 950px !important;
}
</style>